var React = require('react');

function ArrowPointer (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"bba89910-81f9-4b0d-a86b-f75ea3d969c3","data-name":"Arrow"},React.createElement("g",{"id":"a02b31fb-7f5f-480e-b13b-84816c151985","data-name":"Group 3537"},[React.createElement("line",{"id":"f722c659-8a4a-4ff4-9cd1-caf34776ffb6","data-name":"Line 635","y1":"5.2","x2":"40","y2":"5.2","style":{"fill":"none"},"key":0}),React.createElement("path",{"id":"add5d5b0-cbcc-4788-82cd-f4f6a68f6c28","data-name":"Point","d":"M35.17.35,40,5.2l-4.83,4.85","transform":"translate(0 0)","style":{"fill":"none","strokeMiterlimit":"10"},"key":1})])));
}

ArrowPointer.defaultProps = {"className":"stroke-current","id":"b2f2a825-c8a7-42e2-bc9b-b5676bede5ac","data-name":"Layer 1","viewBox":"0 0 40.71 10.4","width":"40","height":"9.69"};

module.exports = ArrowPointer;

ArrowPointer.default = ArrowPointer;
